import * as React from "react";
import "../Styles/style.css";
import cover from "../../images/About-banner.jpg";
import img1 from "../../images/munawar-abbas.png";
import img2 from "../../images/photos/arham-abbas.jpg";
import img3 from "../../images/photos/4 (2).png";
import img4 from "../../images/photos/1 (3).png";
import img5 from "../../images/photos/gm.png";
import img6 from "../../images/photos/emaan-boss.png";
import img7 from "../../images/photos/legal-advisor.jpg";
import img8 from "../../images/photos/legal-director-shoaib.jpg";
import img9 from "../../images/photos/hyderShaikh.jpg";
import img10 from "../../images/photos/amir.jpg";
import img11 from "../../images/photos/mehroz.jpg";
import img12 from "../../images/photos/ahsanjpg.jpg";
import img13 from "../../images/photos/fouzia.jpg";
import img14 from "../../images/photos/tauqeer.jpg";
import img15 from "../../images/photos/arham-qazi.jpg";

export default function AboutUs() {
  return (
    <>
      <div className="infoMainConatiner py-5">
        <div className="container">
          <h4 className="termsMainHeading">About Us</h4>

          <div className="infoMainBody p-3">
            <div>
              <img
                className="aboutus_cover"
                src={cover}
                alt="FameWeels"
                loading="lazy"
              />
            </div>
            <p className="text-center mt-4">
              Fame Business Solutions, the glimmering and multifaceted
              conglomerate opulent with huge and diverse portfolio of businesses
              belongs to the brand Fame, is ready to start a project of "Fame
              Wheels" in Pakistan. This is definitely a strategic and advanced
              plan that is aimed at making a huge difference in the whole
              automobiles buying and selling areas, focuses upon the highly
              personalized experience.
              <br />
              <br />
              The foundation of the innovative method employed by Fame Wheels is
              a top-notch bidding system, provides the users with an interactive
              and modern interface that makes the process of buying and selling
              automobiles more simplified and satisfactory. Alongside this
              platform, the company keeps high-quality premium services in
              stock, including comprehensive, reliable and thoroughly checked
              inspection services.
              <br />
              <br />
              The distinctive aspect does not only lend an adventurous element
              and adequate atmosphere of competition to the business of vehicle
              trading but also provides a fair and clear phase of transactions.
              <br />
              <br />
              To start with, Fame Wheels stands on the pillar of excellence,
              ethical practices, and absolute clarity. Therefore, Fame Wheels is
              not just an entrepreneurial venture, but a mission to make the
              automotive community more vibrant. Through enabling the people and
              enriching everlasting unions, Fame Wheels is on the verge of
              becoming an epitome of creativity and development in the field of
              the automotive.
              <br />
              <br />
              Our stable dedication to the quality management is manifested in
              every aspect of our work. Innovative approaches in combination
              with client-centric services are just the beginning of our range
              of superior services. Our venture into the automotive sector is
              not just an expansion of our business activity; it is a key mark
              of our ongoing path. It is our core duty to serve our clients with
              excellent financial services, customized advisory services and
              unique investment strategies purposely designed to meet the
              exclusive objectives of our refined clients.
              <br />
              <br />
              One of the primary goals of FameWheels.com is a smooth
              interaction. We have put a good deal of investment in ensuring
              that our website is not only informational and easy to navigate
              but also a basically a representation of our commitment to quality
              and excellence. This mission and this oath to give the best online
              experience to every guest, each time.
            </p>
            <br />

            {/* bod */}
            <div>
              <div className="row mx-5">
                <h4 className="color-blue text-center fw-700">
                  Board of Directors
                </h4>
                <div className="col-lg-4 col-12 text-center shadow-lg p-3 mb-5 m-2 bg-white rounded aboutus_profile">
                  <div>
                    <img
                      className="aboutus_photos"
                      src={img1}
                      alt="CHAIRMAN"
                      loading="lazy"
                    />
                  </div>
                  <p className="about_profile_desig">
                    FOUNDER - CHAIRMAN & CEO
                  </p>
                  <h5 className="about_profile_name">MUNAWAR ABBAS SHAIKH</h5>
                  <p className="about_profile_exp">
                    Munawar Abbas Shaikh is Chairman Fame Business Soutions, he
                    has done a MBA and LLB. He has more than 18 years of
                    experience in diverse industries.
                  </p>
                </div>

                <div className="col-lg-4 col-12 text-center shadow-lg p-3 mb-5 m-2 bg-white rounded aboutus_profile">
                  <div>
                    <img
                      className="aboutus_photos"
                      src={img2}
                      alt="GENERAL MANAGER"
                      loading="lazy"
                      style={{ objectPosition: "top" }}
                    />
                  </div>
                  <p className="about_profile_desig">C0-FOUNDER - DIRECTOR</p>
                  <h5 className="about_profile_name">ARHAM ABBAS SHAIKH</h5>
                  <p className="about_profile_exp">
                    Arham Abbas Shaikh, combines a passion for cars with an
                    entrepreneurial mindset. A dedicated enthusiast with
                    extensive global car knowledge, he enjoys both maintaining
                    his collection and providing upgrade suggestions for others.
                  </p>
                </div>
                <div className="col text-center shadow-lg p-3 mb-5 m-2 bg-white rounded aboutus_profile">
                  <div>
                    <img
                      className="aboutus_photos"
                      src={img9}
                      alt="CHIEF OPERATING OFFICER"
                      loading="lazy"
                    />
                  </div>
                  <p className="about_profile_desig">DIRECTOR</p>
                  <h5 className="about_profile_name">GHULAM HYDER SHAIKH</h5>
                  <p className="about_profile_exp">
                    Ghulam Hyder is a dynamic professional and passionate car
                    enthusiast, known for his energy and dedication to the
                    automotive world.
                  </p>
                </div>
              </div>
              <div className="row mx-5">
                {/* <div className="col-lg-4 col-12 text-center shadow-lg p-3 mb-5 m-2 bg-white rounded aboutus_profile">
                  <div>
                    <img
                      className="aboutus_photos"
                      src={img5}
                      alt="GENERAL MANAGER"
                      loading="lazy"
                    />
                  </div>
                  <p className="about_profile_desig">
                    Co-Founder / General Manager
                  </p>
                  <h5 className="about_profile_name">
                    RASHA TAREK FAKHREL DEEN
                  </h5>
                  <p className="about_profile_exp">
                    RASHA TAREK FAKHREL DEEN has more then of 15 years of
                    management and marketing experience in multinational
                    companies. She has a MSc in Development Studies from SOAS
                    University of London and a MBA from IBA Karachi.
                  </p>
                </div> */}
                {/* <div className="col text-center shadow-lg p-3 mb-5 m-2 bg-white rounded aboutus_profile">
                  <div>
                    <img
                      className="aboutus_photos"
                      src={img2}
                      alt="Co-Founder"
                      loading="lazy"
                    />
                  </div>
                  <p className="about_profile_desig">Co-Founder</p>
                  <h5 className="about_profile_name">ARHAM ABBAS SHAIKH</h5>
                  <p className="about_profile_exp">
                    Arham Abbas Shaikh, A-Levels student at Lyceum School,
                    combines a passion for cars with an entrepreneurial mindset.
                    A dedicated enthusiast with extensive global car knowledge,
                    he enjoys both maintaining his collection and providing
                    upgrade suggestions for others.
                  </p>
                </div> */}
                {/* <div className="col-lg-4 col-12 text-center shadow-lg p-3 mb-5 m-2 bg-white rounded aboutus_profile">
                  <div>
                    <img
                      className="aboutus_photos"
                      src={img7}
                      alt="GENERAL MANAGER"
                      loading="lazy"
                      style={{ objectPosition: "top" }}
                    />
                  </div>
                  <p className="about_profile_desig">Legal Advisor</p>
                  <h5 className="about_profile_name">Salman Asghar Sheikh</h5>
                  <p className="about_profile_exp">
                    Mr. Salman Asghar Shaikh is an Advocate of the High Courts
                    of Pakistan. He has a vast experience of representing
                    various clients before the High Courts in matters ranging
                    from Civil Law, Commercial Law, Constitutional Law, Media
                    Law, Banking Law, Corporate Law, Taxation, Property Law,
                    Labour and Employment matters.
                  </p>
                </div> */}
                {/* <div className="col text-center shadow-lg p-3 mb-5 m-2 bg-white rounded aboutus_profile">
                  <div>
                    <img
                      className="aboutus_photos"
                      src={img6}
                      alt="Co-Founder"
                      loading="lazy"
                    />
                  </div>
                  <p className="about_profile_desig">Co-Founder</p>
                  <h5 className="about_profile_name">EMAAN SHAIKH</h5>
                  <p className="about_profile_exp">
                    Emaan Shaikh is an O-level student and one of the
                    co-founders of FameWheels. She is a passionate car
                    enthusiast with extensive knowledge of vehicles. A dynamic
                    individual, she possesses expertise in digital marketing and
                    a profound understanding of vehicles. It is anticipated that
                    she will lead the company to global prominence in the
                    future. Despite her young age of 14, Emaan has amassed a
                    significant following and a thriving community of car
                    enthusiasts. She is particularly fond of drifting and adept
                    at driving various vehicles.
                  </p>
                </div> */}
              </div>
              <div className="row mx-5">
                <div className="col-lg-4 col-12 text-center shadow-lg p-3 mb-5 m-2 bg-white rounded aboutus_profile">
                  <div>
                    <img
                      className="aboutus_photos"
                      src={img12}
                      alt="DIRECTOR BUSINESS"
                      loading="lazy"
                    />
                  </div>
                  <p className="about_profile_desig">DIRECTOR</p>
                  <h5 className="about_profile_name">AHSAN SHAIKH</h5>
                  <p className="about_profile_exp">
                    Ahsan is a seasoned entrepreneur and passionate car
                    enthusiast with extensive experience in the automotive
                    industry.
                  </p>
                </div>
                <div className="col-lg-4 col-12 text-center shadow-lg p-3 mb-5 m-2 bg-white rounded aboutus_profile">
                  <div>
                    <img
                      className="aboutus_photos 1"
                      src={img8}
                      alt="GENERAL MANAGER"
                      loading="lazy"
                      style={{ objectPosition: "top" }}
                    />
                  </div>
                  <p className="about_profile_desig">Director legal</p>
                  <h5 className="about_profile_name">SHOAIB KHAN</h5>
                  <p className="about_profile_exp">
                    Mr.Shoaib Khan is an Associate at De Solution Advocates &
                    Tax Consultants, specializing in tax matters and corporate
                    law. He has experience defending tax claims at the High
                    Court, managing tax returns, and overseeing sales and
                    withholding taxes. He also handles company formation, drafts
                    legal agreements, and manages trademark registrations.
                  </p>
                </div>
              </div>
            </div>

            {/* management */}
            <div>
              <div className="row mx-5">
                <h4 className="color-blue text-center fw-700 mt-5">
                  Management
                </h4>
                <div className="col text-center shadow-lg p-3 mb-5 m-2 bg-white rounded aboutus_profile">
                  <div>
                    <img
                      className="aboutus_photos"
                      src={img3}
                      alt="DIRECTOR BUSINESS"
                      loading="lazy"
                    />
                  </div>
                  <p className="about_profile_desig">CO-FOUNDER</p>
                  <h5 className="about_profile_name">SYED MUBASHIR ABBAS</h5>
                  <p className="about_profile_exp">
                    Syed Mubashir Abbas is a seasoned Consumer Banking
                    professional with an experience of 20 years in Branch
                    Banking.
                  </p>
                </div>
                <div className="col-lg-4 col-12 text-center shadow-lg p-3 mb-5 m-2 bg-white rounded aboutus_profile">
                  <div>
                    <img
                      className="aboutus_photos"
                      src={img6}
                      alt="GENERAL MANAGER"
                      loading="lazy"
                    />
                  </div>
                  <p className="about_profile_desig">Co-Founder</p>
                  <h5 className="about_profile_name">EMAAN SHAIKH</h5>
                  <p className="about_profile_exp">
                    Emaan Shaikh is an O-level student and one of the
                    co-founders of FameWheels. She is a passionate car
                    enthusiast with extensive knowledge of vehicles. A dynamic
                    individual, she possesses expertise in digital marketing and
                    a profound understanding of vehicles. It is anticipated that
                    she will lead the company to global prominence in the
                    future. Despite her young age of 14, Emaan has amassed a
                    significant following and a thriving community of car
                    enthusiasts. She is particularly fond of drifting and adept
                    at driving various vehicles.
                  </p>
                </div>
                <div className="col-lg-4 col-12 text-center shadow-lg p-3 mb-5 m-2 bg-white rounded aboutus_profile">
                  <div>
                    <img
                      className="aboutus_photos"
                      src={img13}
                      alt="GENERAL MANAGER"
                      loading="lazy"
                    />
                  </div>
                  <p className="about_profile_desig">Co-Founder</p>
                  <h5 className="about_profile_name">Fouzia Shaikh</h5>
                  <p className="about_profile_exp">
                    Fouzia has extensive experience in driving growth and
                    innovation at FameWheels. With a strong background in
                    Quality Assurance, finance, and project leadership, she
                    excels in leading teams and delivering impactful results.
                  </p>
                </div>
              </div>
              <div className="row mx-5">
                <div className="col-lg-4 text-center shadow-lg p-3 mb-5 bg-white rounded aboutus_profile">
                  <div>
                    <img
                      className="aboutus_photos"
                      src={img4}
                      alt="DIRECTOR BUSINESS"
                      loading="lazy"
                    />
                  </div>
                  <p className="about_profile_desig">Co-Founder - COO</p>
                  <h5 className="about_profile_name">ABDUL SATTAR ABRO</h5>
                  <p className="about_profile_exp">
                    Abdul Sattar Abro is Chief Operating Officer and he has more
                    than 14 years of Customer Service & Business Development
                    experience.
                  </p>
                </div>
                <div className="col-lg-4 text-center shadow-lg p-3 mb-5 bg-white rounded aboutus_profile">
                  <div>
                    <img
                      className="aboutus_photos"
                      src={img10}
                      alt="CHIEF OPERATING OFFICER"
                      loading="lazy"
                    />
                  </div>
                  <p className="about_profile_desig">General Manager</p>
                  <h5 className="about_profile_name">AMIR SHAMIM</h5>
                  <p className="about_profile_exp">
                    22 years experience in Blue Chip NBFI, Main Stream Media
                    Marketing, Brand Management, Business Development Tools,
                    Event Management, Strategic Corporate Collaboration,
                    Training and Development and PR. make it professional.
                  </p>
                </div>
                <div className="col-lg-4 text-center shadow-lg p-3 mb-5 bg-white rounded aboutus_profile">
                  <div>
                    <img
                      className="aboutus_photos"
                      src={img11}
                      alt="CHIEF OPERATING OFFICER"
                      loading="lazy"
                    />
                  </div>
                  <p className="about_profile_desig">CTO</p>
                  <h5 className="about_profile_name">MUHAMMAD MEHROZ</h5>
                  <p className="about_profile_exp">
                    Experienced Software Engineer with a strong background in IT
                    and a passion for automation. Skilled in web technologies,
                    cloud infrastructure, and process optimization. Enthusiastic
                    about DevOps culture and team collaboration, with a focus on
                    driving innovation. Eager to take on leadership roles and
                    contribute to the growth of technology teams.
                  </p>
                </div>
              </div>

              <div className="row mx-5">
                <div className="col-lg-4 text-center shadow-lg p-3 mb-5 bg-white rounded aboutus_profile">
                  <div>
                    <img
                      className="aboutus_photos"
                      src={img15}
                      alt="DIRECTOR BUSINESS"
                      loading="lazy"
                    />
                  </div>
                  <p className="about_profile_desig">AUCTION HEAD</p>
                  <h5 className="about_profile_name">ARHAM ALI QAZI</h5>
                  <p className="about_profile_exp">
                    He is a head of auction and he has more than 17+ years of
                    experience in automobile & web e-commerce industry.
                  </p>
                </div>
                <div className="col-lg-4 text-center shadow-lg p-3 mb-5 bg-white rounded aboutus_profile">
                  <div>
                    <img
                      className="aboutus_photos"
                      src={img14}
                      alt="CHIEF OPERATING OFFICER"
                      loading="lazy"
                    />
                  </div>
                  <p className="about_profile_desig">HEAD OF SALES</p>
                  <h5 className="about_profile_name">SYED TAUQEER ALI</h5>
                  <p className="about_profile_exp">
                    I am seasoned sales professional with over 12 years of
                    experiece in the automobile industry. Currently, I'm serving
                    as the Head of Sales at FameWheels.
                  </p>
                </div>
                <div className="col-lg-4 text-center shadow-lg p-3 mb-5 bg-white rounded aboutus_profile">
                  <div>
                  <img
                      className="aboutus_photos"
                      src={img5}
                      alt="DIRECTOR BUSINESS"
                      loading="lazy"
                    />
                  </div>
                  <p className="about_profile_desig">CO-FOUNDER</p>
                  <h5 className="about_profile_name">
                    RASHA TAREK FAKHREL DEEN
                  </h5>
                  <p className="about_profile_exp">
                    Rasha has more then of 15 years of management and marketing
                    experience in multinational companies. She has a MSc in
                    Development Studies from SOAS University of London and a MBA
                    from IBA Karachi.
                  </p>
                </div>
              </div>

              <div className="row mx-5">
                {/* <div className="col-lg-4 text-center shadow-lg p-3 mb-5 bg-white rounded aboutus_profile">
                  <div>
                    <img
                      className="aboutus_photos"
                      src={img4}
                      alt="DIRECTOR BUSINESS"
                      loading="lazy"
                    />
                  </div>
                  <p className="about_profile_desig">Auction Head</p>
                  <h5 className="about_profile_name">ARHAM ALI QAZI</h5>
                  <p className="about_profile_exp">
                    Abdul Sattar Abro is Chief Operating Officer and he has more
                    than 14 years of Customer Service & Business Development
                    experience.
                  </p>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

{
  /* <div className="col-lg-4 text-center shadow-lg p-3 mb-5 bg-white rounded aboutus_profile">
                  <div>
                    <img
                      className="aboutus_photos"
                      src={img5}
                      alt="DIRECTOR BUSINESS"
                      loading="lazy"
                    />
                  </div>
                  <p className="about_profile_desig">CO-FOUNDER</p>
                  <h5 className="about_profile_name">
                    RASHA TAREK FAKHREL DEEN
                  </h5>
                  <p className="about_profile_exp">
                    Rasha has more then of 15 years of management and marketing
                    experience in multinational companies. She has a MSc in
                    Development Studies from SOAS University of London and a MBA
                    from IBA Karachi.
                  </p>
                </div> */
}
